import { z } from "zod";

export const validateOrderPaymentShareableLinkTokenRequestSchema = z.object({
  accessToken: z.string(),
});

export type TValidateOrderPaymentShareableLinkTokenRequest = z.infer<
  typeof validateOrderPaymentShareableLinkTokenRequestSchema
>;
